// extracted by mini-css-extract-plugin
export var photo = "photo-module--photo--YV5jr";